// Actions
export const SWITCHTHEME = "global/SWITCHTHEME";

// scopeReducers

// Reducer
export default function reducer(state = {}, { type, data }) {
    switch (type) {
    case SWITCHTHEME:
        console.log(data);
        return state;
    default: return state;
    }
}

// Action Creators
export function switchTheme(isDarkTheme, { scopeID }) {
    return { type: SWITCHTHEME, meta: { scopeID }, data: { isDarkTheme } };
}
